var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoExciskillsWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.9 171",
    style: {
      enableBackground: "new 0 0 167.9 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#F20000;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -27.1,
    y: -18.1,
    className: "st1",
    width: 236.7,
    height: 200.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "personnes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "milieu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79,141.2c-12.8-5.8-18.1-14.1-15.6-24.4c2.2-9.1,10.9-15.4,21-15.2c10.1,0.2,18,6.5,19.9,15.6 c2.2,10.9-2.6,18.5-16.1,24.2c13.1,4.5,20.3,12.6,18.5,26.9H61.8C58.9,157.4,62.8,151.2,79,141.2z M101.1,121.9 c0.1-10.4-6.6-17.3-16.7-17.4c-9.5-0.3-17.5,6.9-17.8,16.3c-0.3,9.3,7.1,17.2,16.6,17.5c0.3,0,0.6,0,0.8,0 C94,138.4,101,131.6,101.1,121.9z M65.8,164.2h36.9c1-9.5-6.1-18.1-15.8-19c-0.4,0-0.8-0.1-1.2-0.1 C73.9,144.5,65.5,152.3,65.8,164.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79,141.2c-12.8-5.8-18.1-14.1-15.6-24.4c2.2-9.1,10.9-15.4,21-15.2c10.1,0.2,18,6.5,19.9,15.6 c2.2,10.9-2.6,18.5-16.1,24.2c13.1,4.5,20.3,12.6,18.5,26.9H61.8C58.9,157.4,62.8,151.2,79,141.2z M101.1,121.9 c0.1-10.4-6.6-17.3-16.7-17.4c-9.5-0.3-17.5,6.9-17.8,16.3c-0.3,9.3,7.1,17.2,16.6,17.5c0.3,0,0.6,0,0.8,0 C94,138.4,101,131.6,101.1,121.9z M65.8,164.2h36.9c1-9.5-6.1-18.1-15.8-19c-0.4,0-0.8-0.1-1.2-0.1 C73.9,144.5,65.5,152.3,65.8,164.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "droit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.3,42.3c-12.8-5.8-18.1-14.1-15.6-24.4c2.2-9.1,10.9-15.4,21-15.2c10.1,0.2,18,6.5,19.9,15.6 c2.2,10.9-2.6,18.5-16.1,24.2c13.1,4.5,20.3,12.6,18.5,26.9h-44.9C117.2,58.5,121.2,52.2,137.3,42.3z M159.4,22.9 c0.1-10.4-6.6-17.3-16.7-17.4c-9.5-0.3-17.5,6.9-17.8,16.3c-0.3,9.3,7.1,17.2,16.6,17.5c0.3,0,0.6,0,0.8,0 C152.3,39.4,159.3,32.6,159.4,22.9z M124.2,65.2H161c1-9.5-6.1-18.1-15.8-19c-0.4,0-0.8-0.1-1.2-0.1 C132.2,45.6,123.9,53.4,124.2,65.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.3,42.3c-12.8-5.8-18.1-14.1-15.6-24.4c2.2-9.1,10.9-15.4,21-15.2c10.1,0.2,18,6.5,19.9,15.6 c2.2,10.9-2.6,18.5-16.1,24.2c13.1,4.5,20.3,12.6,18.5,26.9h-44.9C117.2,58.5,121.2,52.2,137.3,42.3z M159.4,22.9 c0.1-10.4-6.6-17.3-16.7-17.4c-9.5-0.3-17.5,6.9-17.8,16.3c-0.3,9.3,7.1,17.2,16.6,17.5c0.3,0,0.6,0,0.8,0 C152.3,39.4,159.3,32.6,159.4,22.9z M124.2,65.2H161c1-9.5-6.1-18.1-15.8-19c-0.4,0-0.8-0.1-1.2-0.1 C132.2,45.6,123.9,53.4,124.2,65.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gauche"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.7,42.3C7.9,36.5,2.6,28.2,5.1,17.9C7.3,8.8,16,2.5,26.1,2.7c10.1,0.2,18,6.5,19.9,15.6 c2.2,10.9-2.6,18.5-16.1,24.2C43,47,50.2,55.1,48.4,69.3H3.5C0.5,58.5,4.5,52.2,20.7,42.3z M42.7,22.9 c0.1-10.4-6.6-17.3-16.7-17.4C16.6,5.2,8.6,12.5,8.2,21.8C7.9,31.1,15.3,39,24.8,39.3c0.3,0,0.6,0,0.8,0 C35.6,39.4,42.7,32.6,42.7,22.9z M7.5,65.2h36.9c1-9.5-6.1-18.1-15.8-19c-0.4,0-0.8-0.1-1.2-0.1C15.6,45.6,7.2,53.4,7.5,65.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.7,42.3C7.9,36.5,2.6,28.2,5.1,17.9C7.3,8.8,16,2.5,26.1,2.7c10.1,0.2,18,6.5,19.9,15.6 c2.2,10.9-2.6,18.5-16.1,24.2C43,47,50.2,55.1,48.4,69.3H3.5C0.5,58.5,4.5,52.2,20.7,42.3z M42.7,22.9 c0.1-10.4-6.6-17.3-16.7-17.4C16.6,5.2,8.6,12.5,8.2,21.8C7.9,31.1,15.3,39,24.8,39.3c0.3,0,0.6,0,0.8,0 C35.6,39.4,42.7,32.6,42.7,22.9z M7.5,65.2h36.9c1-9.5-6.1-18.1-15.8-19c-0.4,0-0.8-0.1-1.2-0.1C15.6,45.6,7.2,53.4,7.5,65.2z"
  })))), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 54.9,
    y1: 36,
    x2: 115.2,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 115.2,
    y1: 138.2,
    x2: 142.6,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 54.9,
    y1: 138.2,
    x2: 25.5,
    y2: 82.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExciskillsWhite);
export default __webpack_public_path__ + "static/media/logo-exciskills-white.2df4aff7ac6f2d5487e22debfaf47879.svg";
export { ForwardRef as ReactComponent };